import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/made-with-many%2Fmwm-time-to%2F"
export const ANNOTATION_TEXT_ALIGNMENT = "left" || "center";
export const ANNOTATION_TEXT_LINE_HEIGHT = "2.5" || "1.5";
export const GALLERY_LINK_LABEL = "WORKS";

const AnnotationsDB = [

    /* Audio annotation starts */
    {
        //Audio
        paintingId: 'W03A01',
        videoId: 'W03A01',
        standaloneVideoElementId: 'W03A01',
        videoURL: 'W03A01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: 'Sample',
        bodyText: null,
        displayMesh: 'N',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        videoPlaySpriteImageURL: '/assets/sprites/audioListenHereGreen.svg',
        videoPauseSpriteImageURL: '/assets/sprites/audioListenHereGreen.svg',
        videoLoop: true,
        videoButtonScale: {x: .3, y: .3, z: .2},
        // videoButtonPos:{x:-11.781 , y:1.5, z:1.027},
        // annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        //videoTextureEncoding: THREE.sRGBEncoding,
    },
    /* Audio annotation ends */
    /* Videos begin */
    {
        paintingId: 'W01V01',
        videoId: 'W01V01',
        standaloneVideoElementId: 'W01V01',
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'W02V01',
        videoId: 'W02V01',
        standaloneVideoElementId: 'W02V01',
        videoURL: 'W02V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'W03V01',
        videoId: 'W03V01',
        standaloneVideoElementId: 'W03V01',
        videoURL: 'W03V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },

    {
        paintingId: 'W04V01',
        videoId: 'W04V01',
        standaloneVideoElementId: 'W04V01',
        videoURL: 'W04V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h5>Time To Dance!</h5>`,
        bodyText: `Tina worked with three groups in Corby  - The Autumn Centre, Lakelands Hospice and an over 65s contemporary dance group held at Hazelwood Neighbourhood Centre.<br>Tina's sessions were to enable everyone a chance to dance, making movement fun, creative and accessible to all. The sessions built on the group’s confidence to interact and try new ideas that encouraged an exploration in movement styles and music.<br>Video produced by Paul Stringer.`,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },


    {
        paintingId: 'W04V02',
        videoId: 'W04V02',
        standaloneVideoElementId: 'W04V02',
        videoURL: 'W04V02.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'W05V01',
        videoId: 'W05V01',
        standaloneVideoElementId: 'W05V01',
        videoURL: 'W05V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    /* Videos end */

    // Wall 1
    {
        paintingId: 'W01T01',
        videoId: null,
        videoURL: null,
        headerText: `<h5>Phiona Richards</h5>`,
        isMediaUsed: 'N',
        bodyText: `Phiona Richards is a Socially Engaged artist based in Corby, Northamptonshire and an Associate Artist for Made With Many. Her award winning work has been exhibited locally, nationally and internationally and she has also made an appearance on the Channel Four series, Kirstie’s Handmade Britain.<br>Her work is a combination of books and stitch, both of which were important to her as a child and have informed many creative adventures. As a Book Sculptor, she creates jewellery and non-functional pieces which form the basis of her book art.<br>Phiona worked with two groups at The Autumn Centre in Corby. These groups discovered what can be made possible using paper in 2D and 3D ways to create a Cube and a Kusudama by using techniques which included collage, stencilling and folding techniques.`,
        ContactURL: 'http://www.rarenotions.co.uk',
    },

    // Wall 2
    {
        paintingId: 'W02T01',
        videoId: null,
        videoURL: null,
        headerText: `<h5>Linzi Bright</h5>`,
        isMediaUsed: 'N',
        bodyText: `Linzi is a Northamptonshire based artist working with a variety of 2D and 3D materials and techniques, and specialises in printmaking and mixed media work. Linzi has worked on many arts projects from one day events to six month community projects, and uses creativity to enable individuals to share ideas and bring communities together.<br>Linzi worked with three groups across Corby - Corby Library, Sandalwood Care Home and Seagrave House Care home. She used a variety of art techniques to encourage participants to explore new skills, have a sense of ownership of their work, developing confidence and a sense of community by taking part in a creative activity.`,
        facebookUrl: 'http://www.facebook.com/ArtistDesignerEducator',
    },
    {
        paintingId: 'W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P01.jpg`,
        headerText: `<h5>Corby Library Group - Black and White Canvas and Paper Cut Work</h5>`,
        bodyText: `Local artist Linzi Bright held weekly workshops in Corby Library. For the first few weeks Linzi introduced the group to different techniques of printmaking and paper cutting.<br>Towards the end of the project the group took ideas from initial experimental work and as a group created a large painted black-and-white abstract work. Alongside this individuals also designed and produced text, print and paper cut 3D pieces.<br>Each new technique and process was inspired by the individuals in the group and how they felt about their community and what art and being creative with others meant to them.<br>As the weeks progressed new friendships were formed. This in turn helped each participant to feel more confident about their creative skills and their place in the community.`,
    },
    {
        paintingId: 'W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P02.jpg`,
        headerText: `<h5>Corby Library Group - Black and White Canvas and Paper Cut Work</h5>`,
        bodyText: `Local artist Linzi Bright held weekly workshops in Corby Library. For the first few weeks Linzi introduced the group to different techniques of printmaking and paper cutting.<br>Towards the end of the project the group took ideas from initial experimental work and as a group created a large painted black-and-white abstract work. Alongside this individuals also designed and produced text, print and paper cut 3D pieces.<br>Each new technique and process was inspired by the individuals in the group and how they felt about their community and what art and being creative with others meant to them.<br>As the weeks progressed new friendships were formed. This in turn helped each participant to feel more confident about their creative skills and their place in the community.`,
    },
    {
        paintingId: 'W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P03.jpg`,
        headerText: `<h5>Corby Library Group - Black and White Canvas and Paper Cut Work</h5>`,
        bodyText: `Local artist Linzi Bright held weekly workshops in Corby Library. For the first few weeks Linzi introduced the group to different techniques of printmaking and paper cutting.<br>Towards the end of the project the group took ideas from initial experimental work and as a group created a large painted black-and-white abstract work. Alongside this individuals also designed and produced text, print and paper cut 3D pieces.<br>Each new technique and process was inspired by the individuals in the group and how they felt about their community and what art and being creative with others meant to them.<br>As the weeks progressed new friendships were formed. This in turn helped each participant to feel more confident about their creative skills and their place in the community.`,
    },
    {
        paintingId: 'W02P04',
        videoId: null,
        videoURL: null,
        // imageURL: `/paintings/W02P04.jpg`,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}W02P04.jpg/info.json`,
        headerText: `<h5>Sandalwood Court Care Home - Landscape</h5>`,
        bodyText: `Linzi Bright visited Sandalwood Court Care Home over a number of weeks. She worked alongside the residents, and with the help of the team in the care home, a giant landscape was created.<br>Each week a new element of the landscape would be created. A variety of techniques were used including felting, batik, scratchboard and mono printing.<br>The final landscape brings together each of the resident’s memories of their own and imagined landscapes, using recognisable images and text.<br>The materials and tools used during this project helped the residents with fine motor skills.<br>During the creative process, this project gave the opportunity for conversation engaging the residents in their community.`,
    },
    {
        paintingId: 'W02P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P05.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,

    },
    {
        paintingId: 'W02P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P06.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,
    },
    {
        paintingId: 'W02P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P07.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,
    },
    {
        paintingId: 'W02P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P08.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,
    },
    {
        paintingId: 'W02P09',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P09.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,
    },
    {
        paintingId: 'W02P10',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P10.jpg`,
        headerText: `<h5>Seagrave House Care Home - Hanging Bird and Back Drop</h5>`,
        bodyText: `Linzi Bright visited Seagrave  House Care Home for four afternoons.<br>As a group residents took part in making a large brightly coloured printed backdrop, where they were encouraged to explore textures and patterns, creating a busy surface.<br>The next stage of the project was to document individuals through text and fingerprints, this created some lively conversation and the residents enjoyed chatting to each other about themselves.<br>Fabric feathers were made by individuals for the wings of the bird, and the residents also drew around their hands to create fabric collages that became the bird’s body.<br>The final stage was to put the bird together and stitch the backdrop.<br>This piece of work each week created a fun atmosphere for residents to come together and enjoy a new experience.`,
    },
    // Wall 3
    {
        paintingId: 'W03T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Ryan Leder</h5>`,
        bodyText: `Ryan Leder is a writer and theatre maker from Northamptonshire. He is an Associate Artist with Made With Many and has made professional work in Corby for nearly a decade. Ryan also runs the Core Playwrights Ensemble at The Core, helping members of the community develop the tools to write their own stories for the stage. His work emerges from engaging with communities via social conversation and formal interviews. The aim of the process is to form first person accounts that can be translated into text imbued with the voice of it's community -  Ryan then responds to the text with his own artistic process in order to create a unique expression for said voice.<br>The poetry was created through interviews with over 65's in Corby. Ryan asked them what they wanted to see from the future of Corby. The work was created in response to the conversation that followed that question.`,
        ContactURL: 'http://www.ryanleder.com',
    },
    {
        paintingId: 'W03T02',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>The Elder Tree Project</h5>`,
        bodyText: `The Elder Tree project is a region wide programme of creative writing activity, led by Writing East Midlands, and aims to celebrate and empower older people, increase their sense of wellbeing and reduce feelings of isolation which some of them may be experiencing.<br>Professional writers Jamie Thrasivoulou and Leanne Moden worked with residents at Seagrave House Care Home in Corby to produce writing around memory, storytelling and reminiscence. This postcard is one in a series of twelve which celebrates the wealth of experience, knowledge and talent these older people bring to their community.<br>The residents had so many incredible stories to share, and it was wonderful to be able to facilitate those conversations. We watched them grow in confidence from week to week, and watched friendships blossom and strengthen too.<br>www.writingeastmidlands.co.uk/lit-lab/celebrating-age/`,
        ContactURL: 'http://www.writingeastmidlands.co.uk/lit-lab/celebrating-age/',
    },
    {
        paintingId: 'W03P01',
        spriteImageURL: process.env.PUBLIC_URL + '/assets/sprites/PoetryYellow.svg',
        annotationScale: {x: .3, y: .3, z: 1},
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=w03p01_found_in_corby_final&pageLayout=singlePage&u=mixedrealitiesltd',
        headerText: `<h5>Found in Corby</h5><h6>Edited by Ryan Leder</h6>`,
        bodyText: `"Corby Stories I, II, III" - Edited by Ryan Leder, featuring Noel France, Brigid Gibbs, Elsa Holmes, and Maria Rowe.<br>'Roots' - Edited by Ryan Leder, words by Noel France<br>'Bubble' - Edited by Ryan Leder, words by Elsa Holmes<br>
'An Abstract' (with English Subtitles)- Edited by Ryan Leder, words by Maria Rowe. Polish translation provided by Maria Rowe.`,

    },
    {
        paintingId: 'W03P03',
        spriteImageURL: process.env.PUBLIC_URL + '/assets/sprites/PoetryYellow.svg',
        annotationScale: {x: .3, y: .3, z: 1},
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?backgroundColor=%23bcbcbc&d=w03p02_who_we_are_final&hideIssuuLogo=true&u=mixedrealitiesltd',
        headerText: `<h5>Who We Are</h5>`,
        bodyText: `<b>A Writing East Midlands Eldertree Project by the Residents of Seagrave House<br>Extract from journal:</b><i>We learnt that the speaking and listening activities are working well for this participant group, and it’s likely that we will finish the project with a series of stories, reminiscences and fragments of memories, rather than fully-formed poems. With this in mind, Jamie and I discussed the possibility of the outcome of the project being a series of high-quality postcards with participants’ printing on them using a high-quality letterpress style design. This is something that we will need to chat to the participants about at the next session.</i><br><b>Extract from journal:</b> <i>During the session, we talked about how the project had impacted on us all, and shared some poems that we’d written, based on participants’ memories. Then we talked about the material we’d gathered from the sessions, and how the participants would like it to be displayed. Participants were really keen on the idea of postcards for their families, and many were really happy that their stories were of interest to the project. We checked with each member that they were happy for their stories to be printed, and agreed the colour and font style for the presentation of the work.<br>Participants were really pleased with the poems that we had written as part of the project, and seemed genuinely delighted that their stories were being valued in this way. Many of the participants have been worried that their stories were ‘not important’ or ‘not exciting’ enough for the project, so being able to show them that they are was a really uplifting and positive thing.</i><br><b>Extract from journal:</b> <i>We learned just how positive the experience of the project has been for many of the residents, and that was really great, given how tricky it has been facilitating the project at times. It seems that the group has really benefited from having a regular chance to come and talk to one another about their own lives. One participant mentioned that it was great to get to know their fellow residents, talking about things they wouldn’t normally discuss, and learning more about one another. We also learnt how excited the group were to see the finished outputs from the group, and how pleased they were to have their lives and stories turned into poems. It was a really nice end to the project, and hopefully they’ll be equally happy with the postcards once they’ve been created.</i>`,
    },
    // Wall 4
    {
        paintingId: 'W04T01',
        videoId: null,
        videoURL: null,
        headerText: `<h5>Tina Heeley</h5>`,
        isMediaUsed: 'N',
        // annotationTextLineHeight: '3.0',
        bodyText: `Tina Heeley is a dance practitioner from Northampton who produces and delivers programmes of dance across the East Midlands. Tina currently specialises in dance and health work promoting emotional, physical and mental well-being through dance, movement and collaborative arts. Tina also runs Dancemind, an arts and health organisation who aspire to nurture and support people through community and health based-arts. The work encompasses an exciting programme of classes and workshops, enthusing health and well-being across a diverse range of people at all stages in life.<br>Tina worked with three groups in Corby  - The Autumn Centre, Lakelands Hospice and an over 65s contemporary dance group held at Hazelwood Neighbourhood Centre.<br>Tina's sessions were to enable everyone a chance to dance, making movement fun, creative and accessible to all. The sessions built on the group’s confidence to interact and try new ideas that encouraged an exploration in movement styles and music.`,
        ContactURL: 'http://www.dancemind.co.uk',
    },

    {
        paintingId: 'W04P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P01.jpg`,
        headerText: `<h5>Lakelands Hospice</h5>`,
    },
    {
        paintingId: 'W04P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P02.jpg`,
        headerText: `<h5>Lakelands Hospice</h5>`,
    },
    {
        paintingId: 'W04P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P03.jpg`,
        headerText: `<h5>The Autumn Centre</h5>`,
    },
    {
        paintingId: 'W04P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P04.jpg`,
        headerText: `<h5>Hazelwood Neighbourhood Centre</h5>`,
    },
    {
        paintingId: 'W04P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P05.jpg`,
        headerText: `<h5>The Autumn Centre</h5>`,
    },
    {
        paintingId: 'W04P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P06.jpg`,
        headerText: `<h5>Lakelands Hospice</h5>`,
    },
    // Survey
    {
        paintingId: 'W04S01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Have Your Say</h5>`,
        bodyText: `Thank you for visiting the gallery. We would really appreciate your feedback on the Time To...project exhibited here. Your feedback helps us to keep extraordinary work for you and our communities free to everyone.`,
        contactUrlLabel: 'SURVEY',
        ContactURL: 'https://www.surveymonkey.co.uk/r/CHDBPFY',
        spriteImageURL:process.env.PUBLIC_URL+'/assets/sprites/Feedbackicon.svg',
        annotationScale: {x:.5,y:.5,z:1},
        displayMesh: 'N',
    },
    // Wall 5
    {
        paintingId: 'W05T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Paul Stringer</h5>`,
        bodyText: `Paul Stringer is an award winning documentary filmmaker and photographer based in Birmingham, UK.<br>Paul has worked with a variety of clients both nationally and internationally in film production, photography and workshop facilitation, including The British Council, University of Birmingham, TEDx, Beatfreeks amongst many others.<br>Alongside commercial work, he is currently working on his first feature documentary film 'Hidden Philosophers' documenting the open mic poetry scene in the U.K. and its impact on society.<br>Paul's role for the Time To project was to document the work and impact with the groups of people across the whole project. When the Coronavirus pandemic forced public events to be put on hold, his role changed to photographer, documenting each artwork created so that it could be displayed digitally and in print, so that the Time To project could have a legacy that didn’t require people to meet in public spaces.<br>www.paulstringer.co.uk`,
        ContactURL: 'http://www.paulstringer.co.uk',

    },
    {
        paintingId: 'W05T02',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Time To...</h5>`,
        bodyText: `Time To….<br>Over the last couple of years, something quite remarkable has been happening across Corby. Older people became artists, in community centres, the library and numerous residential care homes. There was dancing, crafting, singing and writing. New friendships were made and old friends learnt something new about each other. There was lots of chat, laughter and most importantly, a bucket load of creativity.<br>We planned to celebrate the work of these artists in a special event at The Core at Corby Cube in March 2020, but circumstances meant that we couldn’t. For the whole team, cancelling that event was one of the most heartbreaking moments of 2020, so we knew that we had to find a way to showcase this work. Here it is, online for you all to enjoy and share. This gallery not only shows you the remarkable art that has been created by older people across Corby, but also gives you the chance to try some of the activities, whatever your age.<br>Time To… was created by residents of Corby aged over 65 with Linzi Bright, Tina Heeley, Ryan Leder, Phiona Richards, Paul Stringer, Leanne Moden  and Jamie Thrasivoulou from Elder Tree.<br>With thanks to: The Autumn Centre, Corby Conservative Club, Corby Library, Glenmoor House, Hazelwood Neighbourhood Centre, Lakelands Hospice, Sandalwood Court and Seagrave House.<br>Time To… was supported by the ScottishPower Foundation, the Larkfleet Community Fund, Arts Council England and Writing East Midlands.<br>Made With Many<br>Made With Many is a programme of new arts and cultural activities focussing on working with local communities in Corby and Wellingborough to ensure that the arts are at the heart of positive change. To find out more visit www.madewithmany.org`,
        ContactURL: 'http://www.madewithmany.org',

    },
    // Wall 6 - Cube
    {
        paintingId: 'W06P05',
        annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        annotationPos: {x: 0.537, y: 1.1, z: 10.39},
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>About</h5>`,
        bodyText: `Created by the participants at the Autumn Centre, and facilitated by artist Phiona Richards. Photography by Andy Eathorne. The images on this cube were inspired by places and memorable times in corby, such as iconic moments and images the participants could relate to.`,
    },
];

export {AnnotationsDB};
